import { render } from "./AppCartItemRemove.vue?vue&type=template&id=ff637c84&ts=true"
import script from "./AppCartItemRemove.vue?vue&type=script&lang=ts"
export * from "./AppCartItemRemove.vue?vue&type=script&lang=ts"

import "./AppCartItemRemove.vue?vue&type=style&index=0&id=ff637c84&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__